import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    configTopicName: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "26px",
        marginTop: "30px",
        display: "flex",
        alignItems: "center",
        letterSpacing: "-0.001em",
        color: "#091E42"
    },
    linesButton: {
        display: "flex",
        marginTop: "10px",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 14px",
        width: "117px",
        height: "49px",
        background: "#F4F6F8",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px"
    },
    threeButton: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "13px 20px",
        background: "#F4F6F8",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "26px",
        letterSpacing: "-0.001em",
        color: "#000000",
        marginRight: "26px"
    },
    threeButton0: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "13px 20px",
        background: "#F4F6F8",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "26px",
        letterSpacing: "-0.001em",
        color: "#000000",

    },
    threeButtonAlign: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    topicConfigtxt: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "26px",
        lineHeight: "30px",
        display: "flex",
        alignItems: "center",
        letterSpacing: "-0.001em",
        color: "#091E42",
        marginTop: "40px"
    },
    topicConfigSubDiv: {
        marginTop: "20px",
        padding: "30px",
        width: "530px",
        height: "145px",
        background: "#FFFFFF",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "12px",

    },
    topicConfigSubDivtxt: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "26px",
        display: "flex",
        alignItems: "center",
        letterSpacing: "-0.001em",
        color: "#091E42"
    },
    topicConfigSubDivbutton: {
        padding: "13px 14px",
        display: "flex",
        flexDirection: "row",
        background: "#F4F6F8",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        width: "113px",
        height: "49px",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "26px",
        alignItems: "center",
        letterSpacing: "-0.001em",
        color: "#000000",
        marginTop: "10px"
    },
    brokerTxt: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "26px",
        lineHeight: "30px",
        display: "flex",
        alignItems: "center",
        letterSpacing: "-0.001em",
        color: "#091E42",
        marginTop: "40px",
        marginBottom: "20px",
    },
    brokerDiv: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: "30px",
        background: "#FFFFFF",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        marginBottom: "40px",
        borderRadius: "12px",
    },
    input: {
        background: "#F4F6F8",
        marginTop: "10px",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        width: "165px",
        height: "52px",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 14px",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "18px",
        lineHeight: "26px",
        letterSpacing: "-0.001em",
        color: "#000000",
        outline: "none",
        '&::placeholder': {
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "18px",
            lineHeight: "26px",
            display: "flex",
            alignItems: "center",
            letterSpacing: "-0.001em",
            color: "#000000"
        }
    },
    input2: {
        background: "#F4F6F8",
        marginTop: "10px",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 14px",
        outline: "none",
        width: "247px",
        height: "52px",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "18px",
        lineHeight: "26px",
        letterSpacing: "-0.001em",
        color: "#000000",
        '&::placeholder': {
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "18px",
            lineHeight: "26px",
            display: "flex",
            alignItems: "center",
            letterSpacing: "-0.001em",
            color: "#000000"
        }
    },
    input3: {
        background: "#F4F6F8",
        marginTop: "10px",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        outline: "none",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 14px",
        width: "307px",
        height: "52px",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "18px",
        lineHeight: "26px",
        letterSpacing: "-0.001em",
        color: "#000000",
        '&::placeholder': {
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "18px",
            lineHeight: "26px",
            display: "flex",
            alignItems: "center",
            letterSpacing: "-0.001em",
            color: "#000000"
        }
    },
    infoIcon: {
        display: "flex",
        alignItems: "center",
        marginLeft: "11px"
    },
    Kafkatxt: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "26px",
        lineHeight: "30px",
        letterSpacing: "-0.001em",
        marginRight: "6px",
        marginBottom: "20px",
        color: "#091E42",
    },
    kafkaDiv: {
        padding: "30px",
        background: "#FFFFFF",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "12px",
        minHeight: "592px",
    },
    kafkaSubDiv:{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
    },
    Kafkainput: {
        background: "#F4F6F8",
        marginTop: "10px",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 14px",
        outline: "none",
        width: "240px",
        height: "52px",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "18px",
        lineHeight: "26px",
        letterSpacing: "-0.001em",
        color: "#000000",
        '&::placeholder': {
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "18px",
            lineHeight: "26px",
            display: "flex",
            alignItems: "center",
            letterSpacing: "-0.001em",
            color: "#000000"
        }
    },
    Kafkainput2: {
        background: "#F4F6F8",
        marginTop: "10px",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 14px",
        outline: "none",
        width: "236px",
        height: "52px",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "18px",
        lineHeight: "26px",
        letterSpacing: "-0.001em",
        color: "#000000",
        '&::placeholder': {
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "18px",
            lineHeight: "26px",
            display: "flex",
            alignItems: "center",
            letterSpacing: "-0.001em",
            color: "#000000"
        }
    },
    Kafkainput3: {
        background: "#F4F6F8",
        marginTop: "10px",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 14px",
        outline: "none",
        width: "228px",
        height: "52px",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "18px",
        lineHeight: "26px",
        letterSpacing: "-0.001em",
        color: "#000000",
        '&::placeholder': {
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "18px",
            lineHeight: "26px",
            display: "flex",
            alignItems: "center",
            letterSpacing: "-0.001em",
            color: "#000000"
        }
    },
    Kafkainput4: {
        background: "#F4F6F8",
        marginTop: "10px",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 14px",
        outline: "none",
        width: "306px",
        height: "52px",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "18px",
        lineHeight: "26px",
        letterSpacing: "-0.001em",
        color: "#000000",
        '&::placeholder': {
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "18px",
            lineHeight: "26px",
            display: "flex",
            alignItems: "center",
            letterSpacing: "-0.001em",
            color: "#000000"
        }
    },
    Kafkainput5: {
        background: "#F4F6F8",
        marginTop: "10px",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 14px",
        outline: "none",
        width: "365px",
        height: "52px",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "18px",
        lineHeight: "26px",
        letterSpacing: "-0.001em",
        color: "#000000",
        '&::placeholder': {
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "18px",
            lineHeight: "26px",
            display: "flex",
            alignItems: "center",
            letterSpacing: "-0.001em",
            color: "#000000"
        }
    },
}))